import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IAngularMyDpOptions, IMyDateModel } from 'angular-mydatepicker';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { Subscription } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Auth } from 'src/app/models/auth';
import { CentroCusto } from 'src/app/models/centro-custo';
import { Colaborador, CollaboratorAddress } from 'src/app/models/colaborador';
import { ColaboradorCadastro } from 'src/app/models/colaborador-cadastro';
import { CollaboratorType } from 'src/app/models/collaborator-type';
import { Conductor } from 'src/app/models/conductors';
import { Departamento } from 'src/app/models/departamento';
import { EnderecoCep, EnderecoCidade } from 'src/app/models/endereco';
import { FormFields } from 'src/app/models/form-field';
import { Unidade } from 'src/app/models/unidade';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CardholderService } from 'src/app/services/cardholder.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ConductorService } from 'src/app/services/conductor.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { EnderecoService } from 'src/app/services/endereco.service';
import { FiltroColaboradorService } from 'src/app/services/filtro-colaborador.service';
import { ColaboratorsGroupService } from 'src/app/services/group/colaborators-group.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { KycType } from 'src/app/shared/enums/kyc.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { TipoSexo } from 'src/app/shared/enums/tipo-sexo.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { environment } from 'src/environments/environment';






@Component({
    selector: 'app-colaborador-edit',
    templateUrl: './colaborador-edit.component.html',
    styleUrls: ['./colaborador-edit.component.scss']
})
export class ColaboradorEditComponent implements OnInit, OnDestroy {
    addressReq: boolean = false;
    temContaSeuValeLog = false;
    temContaDespesas = false;

    constructor(
        private formBuilder: FormBuilder,
        private colaboradorService: ColaboradorService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute,
        private centroCustoService: CentroCustoService,
        private unidadeService: UnidadeService,
        private departamentoService: DepartamentoService,
        private parametrosDataService: ParametrosDataService,
        private filterService: FiltroColaboradorService,
        private groupService: ColaboratorsGroupService,
        private addressService: EnderecoService,
        private conductorService: ConductorService,
        private cardholderService: CardholderService
    ) {
        this.onResize();
        this.disableSince(new Date());
    }

    public get form() {
        return this.colaboradorFormGroup.controls;
    }

    private addressCEP: EnderecoCep;
    private enderecoCidade: EnderecoCidade[];
    emptyCity: boolean = true;
    emptyUf: boolean = true;


    public myDatePickerOptions: IAngularMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        minYear: 1901,
        maxYear: 2078,
        monthLabels: {
            1: 'Janeiro',
            2: 'Fevereiro',
            3: 'Março',
            4: 'Abril',
            5: 'Maio',
            6: 'Junho',
            7: 'Julho',
            8: 'Agosto',
            9: 'Setembro',
            10: 'Outubro',
            11: 'Novembro',
            12: 'Dezembro'
        },
        dayLabels: {
            su: 'Dom',
            mo: 'Seg',
            tu: 'Ter',
            we: 'Qua',
            th: 'Qui',
            fr: 'Sex',
            sa: 'Sáb'
        },
        stylesData: {
            selector: 'dp1',
            styles: `
              .dp1 .myDpIconLeftArrow,
              .dp1 .myDpIconRightArrow,
              .dp1 .myDpHeaderBtn {
                 color: #6c757d;
              }
              .dp1 .myDpHeaderBtn:focus,
              .dp1 .myDpMonthLabel:focus,
              .dp1 .myDpYearLabel:focus {
                 color: #aaa;
              }
              .dp1 .myDpDaycell:focus,
              .dp1 .myDpMonthcell:focus,
              .dp1 .myDpYearcell:focus {
                 box-shadow: inset 0 0 0 1px #ccc;
              }
              .dp1 .myDpSelector:focus {
                 box-shadow: -1px 1px 6px 0px #bbb;
              }
              .dp1 .myDpSelectorArrow:focus:before {
                 border-bottom-color: #bbb;
              }
              .dp1 .myDpCurrMonth,
              .dp1 .myDpMonthcell,
              .dp1 .myDpYearcell {
                 color: #6c757d;
              }
              .dp1 .myDpDaycellWeekNbr {
                 color: #6c757d;
              }
              .dp1 .myDpPrevMonth,
              .dp1 .myDpNextMonth {
                 color: #aaa;
              }
              .dp1 .myDpWeekDayTitle {
                 background-color: transparent;
                 color: #6c757d;
              }
              .dp1 .myDpHeaderBtnEnabled:hover,
              .dp1 .myDpMonthLabel:hover,
              .dp1 .myDpYearLabel:hover {
                 color: #212529;
              }
              .dp1 .myDpMarkCurrDay,
              .dp1 .myDpMarkCurrMonth,
              .dp1 .myDpMarkCurrYear {
                 border-bottom: 2px solid #6c757d;
              }
              .dp1 .myDpDisabled {
                 color: #999;
              }
              .dp1 .myDpHighlight {
                 color: #cd5c5c;
              }
              .dp1 .myDpTableSingleDay:hover,
              .dp1 .myDpTableSingleMonth:hover,
              .dp1 .myDpTableSingleYear:hover {
                 background-color: #ccc;
                 color: #222;
              }
              .dp1 .myDpRangeColor {
                 background-color: #eee;
              }
              .dp1 .myDpSelectedDay,
              .dp1 .myDpSelectedMonth,
              .dp1 .myDpSelectedYear {
                 background-color: #ccc;
                 color: #222;
              }
            `
        }
    };
    public myDatePickerOptions2 = this.myDatePickerOptions;
    dateMask = MaskedDate;

    private currentUser: Auth;
    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];
    public MASKS = MASKS;
    public TipoSexo = TipoSexo;
    public colaborador: Colaborador;
    private address: CollaboratorAddress;
    private id: number;
    private routeSubscription: Subscription;
    public isMobile = false;

    public cnhValid: boolean;
    public cnhDataExpiracaoValid: boolean;

    colaboradorCadastro: ColaboradorCadastro;
    colaboradorFormGroup: FormGroup;
    canEdit = false;
    minimumAge = 18;

    private parametros: { [key: string]: string };
    public labelMatricula = 'Matrícula';
    public labelCentroCusto = 'Centro de Custo';
    public labelUnidade = 'Unidade';
    public labelDepartamento = 'Departamento';

    public mostrarColunaAplicativo = true;
    public mostrarColunaCentroCusto = true;
    public mostrarColunaUnidade = true;
    public mostrarColunaDepartamento = true;

    public permitirEditarMatricula = true;
    isUnidadeRequired = false;
    public maxAge = 200;
    public permitirGerenciarCartoesBeneficio = true;

    public persistFilter = false;

    public cadastroColaboradorEmailObrigatorio = false;
    public cadastroColaboradorTelefoneObrigatorio = true;

    public collaboratorType: CollaboratorType[];
    public documentReq = true;
    public birthDateReq = true;
    public phoneReq = true;
    public emailReq = false;
    public motherNameReq = true;

    kycValidated = false;

    tipoColaborador: any = 1;
    campoFormulario: FormFields[];

    readOnlyDyn = true;

    gestorCadastro: string = null;
    dataCadastro: Date;
    gestorAlteracao: string = null;
    dataAlteracao: Date;
    conductor: Conductor;
    cardholder: any;

    disableSince(d: Date) {
        d.setDate(d.getDate() + 1);
        const copy = this.getCopyOfOptions();
        copy.disableSince = {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            day: d.getDate() - 1
        };
        this.myDatePickerOptions = copy;
        return this.myDatePickerOptions;
    }

    getCopyOfOptions() {
        return JSON.parse(JSON.stringify(this.myDatePickerOptions));
    }
    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.isMobile = window.innerWidth <= 500;
    }

    ngOnInit() {
        this.isUnidadeRequired = this.getUnityRequirement();
        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = +params.get('id');
        });

        this.currentUser = this.authenticationService.currentUserValue;

        this.createForm(
            new ColaboradorCadastro(
                '',
                '',
                '',
                null,
                null,
                null,
                '',
                '',
                '',
                '',
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                ''
            )
        );
        if (!this.permitirEditarMatricula) {
            this.colaboradorFormGroup.get('matricula').disable();
        }

        this.colaboradorService.getById(this.id, this.currentUser.token.assignorGuid).pipe(
            map(response => {
                this.colaborador = response.result;

                if (this.colaborador) {
                    if(this.colaborador.documento){
                        const tam =
                            environment.TOTAL_CARACTERE_CPF -
                            this.colaborador.documento.length;
                        let str = this.colaborador.documento.toString();
                        for (let i = 0; i < tam; i++) {
                            str = '0' + str;
                        }
                        this.colaborador.documento = str;
                    }
                    if(!this.colaborador.documento)
                        this.readOnlyDyn = false;
                    /*const dataNascimento = new Date(
                        this.colaborador.dataNascimento
                    );
                    this.colaborador.dataNascimento = {
                        date: {
                            year: dataNascimento.getFullYear(),
                            month: dataNascimento.getMonth() + 1,
                            day: dataNascimento.getDate()
                        },
                        formatted: `${dataNascimento.getFullYear()}/${dataNascimento.getMonth() +
                            1}/${dataNascimento.getDate()}`
                    };*/

                    if(this.colaborador.suspensaoInicio){
                        const suspensaoInicio = new Date(
                            this.colaborador.suspensaoInicio
                        );
                        this.colaborador.suspensaoInicio = {
                            date: {
                                year: suspensaoInicio.getFullYear(),
                                month: suspensaoInicio.getMonth() + 1,
                                day: suspensaoInicio.getDate()
                            },
                            formatted: `${suspensaoInicio.getFullYear()}/${suspensaoInicio.getMonth() +
                                1}/${suspensaoInicio.getDate()}`
                        };
                    }
                    if(this.colaborador.suspensaoFim){
                        const suspensaoFim = new Date(
                            this.colaborador.suspensaoFim
                        );
                        this.colaborador.suspensaoFim = {
                            date: {
                                year: suspensaoFim.getFullYear(),
                                month: suspensaoFim.getMonth() + 1,
                                day: suspensaoFim.getDate()
                            },
                            formatted: `${suspensaoFim.getFullYear()}/${suspensaoFim.getMonth() +
                                1}/${suspensaoFim.getDate()}`
                        };
                    }
                    this.gestorCadastro = this.colaborador.pessoaCadastro;
                    this.dataCadastro = this.colaborador.dataCadastro;
                    this.gestorAlteracao = this.colaborador.pessoaAlteracao;
                    this.dataAlteracao = this.colaborador.dataAlteracao;

                    this.tipoColaborador = this.colaborador.tipoColaborador;
                    this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
                    this.tipocolaborador(this.tipoColaborador);
                }

                return this.colaborador;
            }),
            mergeMap(() => {
                return this.colaboradorService.getCollaboratorAddress(this.colaborador.colaboradorId, this.currentUser.token.assignorGuid).pipe(
                    map(res => {
                        if(res.status == ApiError.Sucesso){
                            this.address = res.result;
                            return this.address;
                        }
                    }
                ))

            }),
            mergeMap((): any => {
                    return this.conductorService.getConductorByCollaborator(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, this.colaborador.colaboradorId).pipe(
                        map(response =>{
                            if(response.status == ApiError.Sucesso)
                            {
                                this.conductor = response.result;
                                return this.conductor;
                            }
                            else
                            {
                                console.log(response.message);
                            }
                        })
                    )

            }),
            mergeMap((): any => {
                    return this.cardholderService.getCardholder(this.colaborador.colaboradorId).pipe(
                        map(response =>{
                            if(response.status == ApiError.Sucesso)
                            {
                                this.cardholder = response.result;
                                return this.cardholder;
                            }
                            else
                            {
                                console.log(response.message);
                            }
                        })
                    )

            }),
            catchError(error => {
               //this.router.navigate(['newpage']);
                console.log(error);
                return error
              })
        ).subscribe(() => {
            this.createForm(
                new ColaboradorCadastro(
                    this.colaborador.email,
                    this.colaborador.nome,
                    this.colaborador.sobrenome,
                    this.colaborador.documento,
                    this.colaborador.dataNascimento,
                    this.colaborador.sexo,
                    this.colaborador.matricula,
                    (this.colaborador.nomeMae === null || this.colaborador.nomeMae == '') ? null : this.colaborador.nomeMae,
                    this.colaborador.nomePai,
                    this.colaborador.celular,
                    this.colaborador.centroCustoId,
                    null,
                    this.colaborador.unidadeId,
                    null,
                    this.colaborador.departamentoId,
                    null,
                    null,
                    null,
                    null,
                    null,
                    this.colaborador.apelido,
                    this.address,
                    null,
                    this.colaborador.suspenso,
                    (this.conductor?.id != null && this.conductor?.deactivationDate == null),
                    (this.cardholder?.id != null && this.cardholder?.endAt == null),
                    this.colaborador.suspensaoInicio,
                    this.colaborador.suspensaoFim,
                    this.conductor?.id,
                    this.conductor?.cnh,
                    this.conductor?.cnhExpirationDate
                )
            );
        })

        this.loadLists();
        this.loadViewConfig();

        this.collaboratorType = JSON.parse(localStorage.getItem('collaboratorType'));

        if (true)
            this.collaboratorType = this.collaboratorType.filter(x => x.collaboratorTypeId != 5);

        this.kycVerification();

    }

    loadViewConfig() {
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros) {
            if (this.parametros[ParametrosKey.idadeMinimaColaborador]) {
                this.minimumAge = +this.parametros[ParametrosKey.idadeMinimaColaborador];
            }
            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaMatriculaColaborador
                ]
            ) {
                this.labelMatricula = this.parametros[
                    ParametrosKey.labelPersonalizadaMatriculaColaborador
                ];
            } else {
                this.labelMatricula = 'Matrícula';
            }
            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ]
            ) {
                this.labelCentroCusto = this.parametros[
                    ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ];
            } else {
                this.labelCentroCusto = 'Centro de Custo';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaUnidadeColaborador
                ]
            ) {
                this.labelUnidade = this.parametros[
                    ParametrosKey.labelPersonalizadaUnidadeColaborador
                ];
            } else {
                this.labelUnidade = 'Unidade';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ]
            ) {
                this.labelDepartamento = this.parametros[
                    ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ];
            } else {
                this.labelDepartamento = 'Departamento';
            }
            if (
                this.parametros[
                ParametrosKey.permitirEditarMatriculaColaborador
                ]
            ) {
                this.permitirEditarMatricula = BooleanConverter.getBoolean(
                    this.parametros[
                    ParametrosKey.permitirEditarMatriculaColaborador
                    ]
                );
            } else {
                this.permitirEditarMatricula = true;
            }

            if (this.parametros[ParametrosKey.idadeMaximaColaborador]) {
                this.maxAge = +this.parametros[ParametrosKey.idadeMaximaColaborador];
            }

            // ao criar o colaborador se true redireciona para a página de cartões
            if (this.parametros[ParametrosKey.permitirGerenciarCartoesBeneficio]) {
                this.permitirGerenciarCartoesBeneficio = BooleanConverter.getBoolean(this.parametros[ParametrosKey.permitirGerenciarCartoesBeneficio]);
            }

            if (this.parametros[ParametrosKey.cadastroColaboradorEmailObrigatorio]) {
                this.cadastroColaboradorEmailObrigatorio = BooleanConverter.getBoolean(this.parametros[ParametrosKey.cadastroColaboradorEmailObrigatorio]);
            }

            if (this.parametros[ParametrosKey.cadastroColaboradorTelefoneObrigatorio]) {
                this.cadastroColaboradorTelefoneObrigatorio = BooleanConverter.getBoolean(this.parametros[ParametrosKey.cadastroColaboradorTelefoneObrigatorio]);
            }

            if (this.parametros[ParametrosKey.temContaSeuValeLog]) {
                this.temContaSeuValeLog = BooleanConverter.getBoolean(this.parametros[ParametrosKey.temContaSeuValeLog]);
            }

            if (this.parametros[ParametrosKey.temContaDespesas]) {
                this.temContaDespesas = BooleanConverter.getBoolean(this.parametros[ParametrosKey.temContaDespesas]);
            }

            if (this.parametros[ParametrosKey.exibirColunaCentroCustoColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaCentroCustoColaboradores]
                )) {
                this.mostrarColunaCentroCusto = false;
            }

            if (this.parametros[ParametrosKey.exibirColunaUnidadeColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaUnidadeColaboradores]
                )) {
                this.mostrarColunaUnidade = false;
            }

            if (this.parametros[ParametrosKey.exibirColunaDepartamentoColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaDepartamentoColaboradores]
                )) {
                this.mostrarColunaDepartamento = false;
            }
        }
    }

    kycVerification(){
        const collaborator = JSON.parse(sessionStorage.getItem('currentCollaborator'));
        if(collaborator.kycValidations != null){
            let kycPhysicalCard = collaborator.kycValidations.find(x=>x.kycTypeId == KycType.PhysicalCard);
            if(kycPhysicalCard.kycValidated){
                this.kycValidated = kycPhysicalCard.kycValidated;
            }
        }
    }

    ngOnDestroy() {
        if (!this.persistFilter) {
            this.filterService.clear();
        }
        this.routeSubscription.unsubscribe();
    }

    goToBack() {
        this.router.navigate(['../../list'], { relativeTo: this.route });
    }

    loadLists() {
        this.centroCustoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.centrosCustosList = response.result;
            });

        this.unidadeService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.unidadesList = response.result;
            });

        this.departamentoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.departamentosList = response.result;
            });
    }

    getDateModel(dataNascimento: any): IMyDateModel {
        const date = new Date();
        if (dataNascimento && dataNascimento.date) {
            date.setFullYear(dataNascimento.date.year);
            date.setMonth(dataNascimento.date.month - 1);
            date.setDate(dataNascimento.date.day);
        }
        return {
            isRange: false,
            singleDate: { jsDate: date },
            dateRange: null
        };
    }

    getDateTime(data: any) {
        const date = new Date();
        if (data && data.date) {
            date.setFullYear(data.date.year);
            date.setMonth(data.date.month - 1);
            date.setDate(data.date.day);
        }
        return date;
    }

    createForm(colaboradorCadastro: ColaboradorCadastro) {
        this.colaboradorFormGroup = this.formBuilder.group({
            email: new FormControl(colaboradorCadastro.email, [
                Validators.maxLength(100),
                Validators.email
            ]),
            nome: new FormControl((colaboradorCadastro.nome + ' ' + colaboradorCadastro.sobrenome), [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            // sobrenome: new FormControl(colaboradorCadastro.sobrenome, [
            //     Validators.required,
            //     Validators.minLength(3),
            //     Validators.maxLength(100)
            // ]),
            documento: new FormControl(
                { value: colaboradorCadastro.documento ? colaboradorCadastro.documento : null, disabled: colaboradorCadastro.documento ? true : false },
                [ NgBrazilValidators.cpf]
            ),
            dataNascimento: new FormControl(
                //new Date().setFullYear(colaboradorCadastro.dataNascimento.date.year).,
                /*[
                    //Validators.required,
                ]*/
                colaboradorCadastro?.dataNascimento!=null?new Date(colaboradorCadastro.dataNascimento):null,[]
            ),
            sexo: new FormControl(colaboradorCadastro.sexo, []),
            matricula: new FormControl(colaboradorCadastro.matricula, []),
            nomeMae: new FormControl(colaboradorCadastro.nomeMae, [
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            nomePai: new FormControl(colaboradorCadastro.nomePai, [
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            celular: new FormControl(
                colaboradorCadastro.celular
                    ? colaboradorCadastro.celular.toString()
                    : '',
                [
                    GenericValidator.isCellPhone,
                    NgBrazilValidators.celular
                ]
            ),
            cnh: new FormControl(colaboradorCadastro.cnh, [
                Validators.maxLength(11)
            ]),
            cnhDataExpiracao: new FormControl(
                colaboradorCadastro.cnhDataExpiracao?this.getDateModel(colaboradorCadastro.cnhDataExpiracao):null
            ),
            centroCustoId: new FormControl(
                colaboradorCadastro.centroCustoId,
                []
            ),
            unidadeId: new FormControl(colaboradorCadastro.unidadeId),
            departamentoId: new FormControl(
                colaboradorCadastro.departamentoId,
                []
            ),
            apelido: new FormControl(colaboradorCadastro.apelido, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(20)
            ]),
            cep: new FormControl(colaboradorCadastro.endereco?.cep, [
                //Validators.maxLength(9),
                NgBrazilValidators.cep
            ]),
            address: new FormControl(colaboradorCadastro.endereco?.address, [
                Validators.maxLength(500),
            ]),
            number: new FormControl(colaboradorCadastro.endereco?.number, [
                Validators.maxLength(10),
            ]),
            complement: new FormControl(colaboradorCadastro.endereco?.complement, [
                Validators.maxLength(50)
            ]),
            neighborhood: new FormControl(colaboradorCadastro.endereco?.neighborhood, [
                Validators.maxLength(200),
            ]),
            city: new FormControl(colaboradorCadastro.endereco?.city, [
            ]),
            uf: new FormControl(colaboradorCadastro.endereco?.uf, [
            ]),
            suspender: new FormControl(colaboradorCadastro.suspender, [
            ]),
            condutor: new FormControl(colaboradorCadastro.condutor, [
            ]),
            portador: new FormControl(colaboradorCadastro.portador, [
            ]),            
            suspensaoInicio: new FormControl(
                colaboradorCadastro.suspensaoInicio?this.getDateModel(colaboradorCadastro.suspensaoInicio):null,
            ),
            suspensaoFim: new FormControl(
                colaboradorCadastro.suspensaoFim?this.getDateModel(colaboradorCadastro.suspensaoFim):null,
            )
        });

        if (this.isUnidadeRequired) {
            this.colaboradorFormGroup
                .get('unidadeId')
                .setValidators(Validators.required);
        }

        if (this.maxAge < 200) {
            this.colaboradorFormGroup
                .controls.dataNascimento.setValidators(
                    [
                        GenericValidator.maximumAge(this.maxAge),
                        Validators.required
                    ]
                );
            this.colaboradorFormGroup.controls.dataNascimento.updateValueAndValidity();
        }

        if (this.cadastroColaboradorEmailObrigatorio) {
            this.colaboradorFormGroup.controls.email.setValidators([
                Validators.email,
                Validators.required
            ]);
            this.colaboradorFormGroup.controls.email.updateValueAndValidity();
        }

        if (this.cadastroColaboradorTelefoneObrigatorio) {
            this.colaboradorFormGroup.controls.celular.setValidators([
                Validators.required,
                GenericValidator.isCellPhone,
                NgBrazilValidators.celular
            ]);
            this.colaboradorFormGroup.controls.celular.updateValueAndValidity();
        }
        this.changeConductorRequired();
        this.changeCardholderRequired();
    }

    semNumero(number: any){
        if(number == null || number == '' || !+number){
            this.colaboradorFormGroup.controls.number.setValue("S/N");
        }
    }

    getAddress(cep: string) {
        if (this.colaboradorFormGroup.get('cep').valid && this.colaboradorFormGroup.get('cep').value) {
            this.addressService.getCEP(cep.replace(/\D+/g, '')).subscribe(
                response => {
                    this.addressCEP = response.result;
                    if(this.addressCEP.uf == null || this.addressCEP.cidade == null){
                        this.emptyUf = false;
                        this.emptyCity = false;
                    }
                    this.setAddress(this.addressCEP);

                }, error => {
                    this.alertService.error('CEP não localizado!');
                }
            );

        }
    }

    setAddress(enderecoCEP?: EnderecoCep) {
        if (enderecoCEP) {
            this.getCity(enderecoCEP.uf);
            this.colaboradorFormGroup.patchValue({
                address: enderecoCEP.logradouro,
                neighborhood: enderecoCEP.bairro,
                city: enderecoCEP.cidade,
                uf: enderecoCEP.uf,
                cep: enderecoCEP.cep,
                number: 'S/N'
            });
        } else {
            return;
        }

    }

    getCity(uf: string) {
        if(uf == null || uf.replace(/\s/g,'') === '')
            uf = null;

        if (uf) {
            this.addressService.getCidade(uf).subscribe(
                response => {
                    this.enderecoCidade = response.result;
                },
                error => {
                    this.alertService.error('Não foi possível carregar as cidades');
                }
            );
        }
    }

    public telefoneCelularMask = (telefone: any) => {
        telefone = telefone.replace(/\D+/g, '').replace(' ', '');
        if (telefone.length <= 11) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        } else if (telefone.length > 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        }
    }

    onSubmit(colaboradorCadastro: ColaboradorCadastro) {
        this.persistFilter = true;
        const dataNascimentoMemoria = colaboradorCadastro.dataNascimento;
        const suspensaoInicioMemoria = colaboradorCadastro.suspensaoInicio;
        const suspensaoFimMemoria = colaboradorCadastro.dataNascimento;

        if (colaboradorCadastro.cnhDataExpiracao) {
            if (colaboradorCadastro.cnhDataExpiracao.singleDate.jsDate) {
                colaboradorCadastro.cnhDataExpiracao = new Date(
                    colaboradorCadastro.cnhDataExpiracao.singleDate.jsDate.getFullYear(),
                    colaboradorCadastro.cnhDataExpiracao.singleDate.jsDate.getMonth(),
                    colaboradorCadastro.cnhDataExpiracao.singleDate.jsDate.getDate()
                );
            }
        }

        /*if (colaboradorCadastro.dataNascimento) {
            if (colaboradorCadastro.dataNascimento.singleDate.jsDate) {
                colaboradorCadastro.dataNascimento = new Date(
                    colaboradorCadastro.dataNascimento.singleDate.jsDate.getFullYear(),
                    colaboradorCadastro.dataNascimento.singleDate.jsDate.getMonth(),
                    colaboradorCadastro.dataNascimento.singleDate.jsDate.getDate()
                );
            }
        }*/

        if (colaboradorCadastro.suspensaoInicio) {
            if (colaboradorCadastro.suspensaoInicio.singleDate.jsDate) {
                colaboradorCadastro.suspensaoInicio = new Date(
                    colaboradorCadastro.suspensaoInicio.singleDate.jsDate.getFullYear(),
                    colaboradorCadastro.suspensaoInicio.singleDate.jsDate.getMonth(),
                    colaboradorCadastro.suspensaoInicio.singleDate.jsDate.getDate(),
                    -3,0,0,0
                );
            }
        }

        if (colaboradorCadastro.suspensaoFim) {
            if (colaboradorCadastro.suspensaoFim.singleDate.jsDate) {
                colaboradorCadastro.suspensaoFim = new Date(
                    colaboradorCadastro.suspensaoFim.singleDate.jsDate.getFullYear(),
                    colaboradorCadastro.suspensaoFim.singleDate.jsDate.getMonth(),
                    colaboradorCadastro.suspensaoFim.singleDate.jsDate.getDate(),
                    -3,0,0,0
                );
            }
        }

        if (colaboradorCadastro.suspender && (colaboradorCadastro.suspensaoInicio==null||colaboradorCadastro.suspensaoFim==null) ){
            this.alertService.error("Datas de suspensão invalidas!");
            return;
        }

        if (colaboradorCadastro.suspensaoInicio > colaboradorCadastro.suspensaoFim){
            let date = colaboradorCadastro.suspensaoInicio;
            colaboradorCadastro.suspensaoInicio = colaboradorCadastro.suspensaoFim;
            colaboradorCadastro.suspensaoFim = date;
        }

        colaboradorCadastro.celular = colaboradorCadastro.celular.replace(/\D+/g, '').replace(' ', '');

        this.changeConductorRequired()
        if (this.colaboradorFormGroup.valid && this.cnhValid && this.cnhDataExpiracaoValid) {

            if(this.form.cep.value){
                colaboradorCadastro.endereco = new CollaboratorAddress();
                colaboradorCadastro.endereco.cep = this.form.cep.value.replace(/\D+/g, '');
                colaboradorCadastro.endereco.address = this.form.address.value;
                colaboradorCadastro.endereco.number = this.form.number.value;
                colaboradorCadastro.endereco.complement = this.form.complement.value;
                colaboradorCadastro.endereco.neighborhood = this.form.neighborhood.value;
                colaboradorCadastro.endereco.city = this.form.city.value;
                colaboradorCadastro.endereco.uf = this.form.uf.value;
            }

            colaboradorCadastro.tipoColaborador = this.tipoColaborador;

            if(colaboradorCadastro.documento != undefined){
                colaboradorCadastro.documento = colaboradorCadastro.documento
                    .replace(/\D+/g, '')
                    .replace(' ', '');
            }
            if(colaboradorCadastro.celular != undefined){
                colaboradorCadastro.celular = colaboradorCadastro.celular
                    .replace(/\D+/g, '')
                    .replace(' ', '');
            }

            if(this.conductor)
                colaboradorCadastro.conductorId = this.conductor.id;

            this.colaboradorService
                .update(
                    this.id,
                    colaboradorCadastro,
                    this.currentUser.token.assignorGuid,
                    this.currentUser.token.userReferenceId
                )
                .subscribe(response => {
                    if (response.status === ApiError.Sucesso) {
                        this.alertService.success(
                            `Favorecido: ${response.result.nome} editado com sucesso!`,
                            true
                        );
                        this.router.navigate(
                            [`list/${colaboradorCadastro.documento}`],
                            { relativeTo: this.route.parent }
                        );
                        /* this.groupService.checkColaboradorTemGrupo(this.currentUser.token.assignorGuid, response.result.colaboradorId).subscribe(
                            res => {
                                if (this.permitirGerenciarCartoesBeneficio && res.result === false) {
                                    this.router.navigate([`cartao/${response.result.colaboradorId}`], { relativeTo: this.route.parent });
                                } else {
                                    this.router.navigate(
                                        [`list/${colaboradorCadastro.documento}`],
                                        { relativeTo: this.route.parent }
                                    );
                                }
                            },
                            error => {
                                this.router.navigate(
                                    [`list/${colaboradorCadastro.documento}`],
                                    { relativeTo: this.route.parent }
                                );
                            }
                        ); */

                    } else {
                        this.alertService.error(response.message);
                    }
                },
                    error => {
                        this.alertService.error(error.error, false);
                    });
        } else {
            GenericValidator.verifierValidatorsForm(this.colaboradorFormGroup);
        }

        this.colaboradorFormGroup.controls.dataNascimento.setValue(dataNascimentoMemoria);
        this.colaboradorFormGroup.controls.suspensaoInicio.setValue(suspensaoInicioMemoria);
        this.colaboradorFormGroup.controls.suspensaoFim.setValue(suspensaoFimMemoria);
    }

    getUnityRequirement(): boolean {
        if (
            this.parametrosDataService.currentParametrosValue &&
            this.parametrosDataService.currentParametrosValue[
            ParametrosKey.exigirUnidadeCadastroColaborador
            ]
        ) {
            return JSON.parse(
                this.parametrosDataService.currentParametrosValue[
                ParametrosKey.exigirUnidadeCadastroColaborador
                ]
            );
        }
        return false;
    }

    tipocolaborador(v?: number, e?: any, toggle: boolean = false){
        if(!v) v = e+1;

        if(v == 1)
        {
            this.tipoColaborador = 1;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
        if(v == 2){
            this.tipoColaborador = 2;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
        if(v == 3){
            this.tipoColaborador = 3;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
        if(v == 4){
            this.tipoColaborador = 4;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
        if(v == 5){
            this.tipoColaborador = 5;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
    }

    changeCardholderRequired(){
        if(this.colaboradorFormGroup.controls.portador.value){
            this.colaboradorFormGroup.controls['centroCustoId'].setValidators([Validators.required]);
        }
        else{
            this.colaboradorFormGroup.controls['centroCustoId'].clearValidators();
            this.colaboradorFormGroup.controls['centroCustoId'].setValidators([]);
        }
        this.colaboradorFormGroup.controls['centroCustoId'].updateValueAndValidity();
    }

    changeConductorRequired(){
        this.cnhValid = true;
        this.cnhDataExpiracaoValid = true;
        if(this.colaboradorFormGroup.controls.condutor.value){
            if(
                this.colaboradorFormGroup.controls.cnh.value == '' ||
                this.colaboradorFormGroup.controls.cnh.value == null
            ){
                this.cnhValid = false;
            }
            if(
                this.colaboradorFormGroup.controls.cnhDataExpiracao.value == '' ||
                this.colaboradorFormGroup.controls.cnhDataExpiracao.value == null
            ){
                this.cnhDataExpiracaoValid = false;
            }
        }
    }

    changeValidator(formField: any){
        this.addressReq = false;
        if(formField.find(x=>x.formFieldName == "Documento")){
            var x = formField.find(x=>x.formFieldName == "Documento")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['documento'].setValidators([Validators.required,NgBrazilValidators.cpf]);
                this.documentReq = true;
            }
            else{
                this.colaboradorFormGroup.controls['documento'].clearValidators();
                this.colaboradorFormGroup.controls['documento'].setValidators([NgBrazilValidators.cpf]);
                this.documentReq = false;
            }

            this.colaboradorFormGroup.controls.documento.updateValueAndValidity();
        }
        if(formField.find(x=>x.formFieldName == "Telefone")){
            var x = formField.find(x=>x.formFieldName == "Telefone")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['celular'].setValidators([Validators.required,
                    GenericValidator.isCellPhone,
                    NgBrazilValidators.celular]);
                this.cadastroColaboradorTelefoneObrigatorio = true;
            }else{
                this.colaboradorFormGroup.controls['celular'].clearValidators();
                this.colaboradorFormGroup.controls['celular'].setValidators([
                    GenericValidator.isCellPhone,
                    NgBrazilValidators.celular
                ]);
                this.cadastroColaboradorTelefoneObrigatorio = false;
            }

            this.colaboradorFormGroup.controls.celular.updateValueAndValidity();
        }
        if(formField.find(x=>x.formFieldName == "Email")){
            var x = formField.find(x=>x.formFieldName == "Email")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['email'].setValidators([Validators.required,Validators.email]);
                this.cadastroColaboradorEmailObrigatorio = true;
            }else{
                this.colaboradorFormGroup.controls['email'].clearValidators();
                this.colaboradorFormGroup.controls['email'].setValidators([Validators.email]);
                this.cadastroColaboradorEmailObrigatorio = false;
            }

            this.colaboradorFormGroup.controls.email.updateValueAndValidity();
        }
        if(formField.find(x=>x.formFieldName == "DataNascimento")){
            var x = formField.find(x=>x.formFieldName == "DataNascimento")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['dataNascimento'].setValidators([Validators.required,GenericValidator.maximumAge(this.maxAge)]);
                this.birthDateReq = true;
            }else{
                this.colaboradorFormGroup.controls['dataNascimento'].clearValidators();
                //this.colaboradorFormGroup.controls['dataNascimento'].setValidators([GenericValidator.maximumAge(this.maxAge)]);
                this.colaboradorFormGroup.controls['dataNascimento'].setValidators([]);
                this.birthDateReq = false;
            }

            this.colaboradorFormGroup.controls['dataNascimento'].updateValueAndValidity();
            this.colaboradorFormGroup.controls.dataNascimento.updateValueAndValidity();
        }
        if(formField.find(x=>x.formFieldName == "NomeMae")){
            var x = formField.find(x=>x.formFieldName == "NomeMae")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['nomeMae'].setValidators([Validators.required,Validators.minLength(3),Validators.maxLength(100)]);
                this.motherNameReq = true;
            }else{
                this.colaboradorFormGroup.controls['nomeMae'].clearValidators();
                this.colaboradorFormGroup.controls['nomeMae'].setValidators([Validators.minLength(3),Validators.maxLength(100)]);
                this.motherNameReq = false;
            }

            this.colaboradorFormGroup.controls.nomeMae.updateValueAndValidity();
        }
        if(this.tipoColaborador === 1 || this.tipoColaborador === 2 || this.tipoColaborador === 5){
            this.addressReq = true;
            this.colaboradorFormGroup.controls['cep'].setValidators([Validators.required,NgBrazilValidators.cep]);
            this.colaboradorFormGroup.controls['address'].setValidators([Validators.required,Validators.maxLength(500)]);
            this.colaboradorFormGroup.controls['number'].setValidators([Validators.required,Validators.maxLength(10)]);
            this.colaboradorFormGroup.controls['complement'].setValidators([Validators.maxLength(50)]);
            this.colaboradorFormGroup.controls['neighborhood'].setValidators([Validators.required,Validators.maxLength(200)]);
            this.colaboradorFormGroup.controls['city'].setValidators([Validators.required]);
            this.colaboradorFormGroup.controls['uf'].setValidators([Validators.required]);
        }
        else{
            this.colaboradorFormGroup.controls['cep'].clearValidators();
            this.colaboradorFormGroup.controls['address'].clearValidators();
            this.colaboradorFormGroup.controls['number'].clearValidators();
            this.colaboradorFormGroup.controls['complement'].clearValidators();
            this.colaboradorFormGroup.controls['neighborhood'].clearValidators();
            this.colaboradorFormGroup.controls['city'].clearValidators();
            this.colaboradorFormGroup.controls['uf'].clearValidators();

            this.colaboradorFormGroup.controls['cep'].setValidators([NgBrazilValidators.cep]);
            this.colaboradorFormGroup.controls['address'].setValidators([Validators.maxLength(500)]);
            this.colaboradorFormGroup.controls['number'].setValidators([Validators.maxLength(10)]);
            this.colaboradorFormGroup.controls['complement'].setValidators([Validators.maxLength(50)]);
            this.colaboradorFormGroup.controls['neighborhood'].setValidators([Validators.maxLength(200)]);

            this.colaboradorFormGroup.controls.cep.updateValueAndValidity();
            this.colaboradorFormGroup.controls.address.updateValueAndValidity();
            this.colaboradorFormGroup.controls.number.updateValueAndValidity();
            this.colaboradorFormGroup.controls.complement.updateValueAndValidity();
            this.colaboradorFormGroup.controls.neighborhood.updateValueAndValidity();
            this.colaboradorFormGroup.controls.city.updateValueAndValidity();
            this.colaboradorFormGroup.controls.uf.updateValueAndValidity();
        }
        this.colaboradorFormGroup.markAsUntouched();
    }
}


export function MaskedDate(event: any) {
    const v = event.target.value;
    if (event.keyCode !== 8) {
        if (v.match(/^\d{2}$/) !== null) {
            event.target.value = v + '/';
        } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
            event.target.value = v + '/';
        }
    }
}
